import AltContainer from 'alt-container';
import connectToStores from 'alt-utils/lib/connectToStores';
import React from 'react';
import AuthStore from 'stores/AuthStore';
import UserDropdown from 'components/UserDropdown';

class UserDropdownContainer extends React.Component {
  static getStores() {
    return [AuthStore];
  }

  static getPropsFromStores() {
    return {
      user: AuthStore.getState().user,
    };
  }

  render() {
    return (
      <AltContainer>
        <UserDropdown {...this.props} />
      </AltContainer>
    );
  }
}

export default connectToStores(UserDropdownContainer);
